import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./styles/LoginPage.css";
import logo from "/assets/logo.svg";
import eyeOpen from "/assets/eyeopen.png";
import eyeClose from "/assets/eyeclose.png";

const ForgotPasswordSetNewPassword = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState({ newPassword: "", confirmPassword: "", passwordMatch: "", server: "", httpRequest: "" });
  const [newPasswordType, setNewPasswordType] = useState("password");
  const [confirmPasswordType, setConfirmPasswordType] = useState("password");
  const phoneForgot = JSON.parse(sessionStorage.getItem("phoneForgot"));
  const email = phoneForgot.email;
  const navigate = useNavigate();

  const handleMouseDownNewPassword = () => {
    setNewPasswordType("text");
  };

  const handleMouseUpNewPassword = () => {
    setNewPasswordType("password");
  };

  const handleMouseDownConfirmPassword = () => {
    setConfirmPasswordType("text");
  };

  const handleMouseUpConfirmPassword = () => {
    setConfirmPasswordType("password");
  };

  const handleNewPasswordChange = (e) => {
    setNewPassword(e.target.value);
    if (error.passwordMatch || error.server) {
      setError((prevError) => ({ ...prevError, passwordMatch: "", newPassword: "", server: "" }));
    }
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
    if (error.passwordMatch || error.server) {
      setError((prevError) => ({ ...prevError, passwordMatch: "", confirmPassword: "", server: "" }));
    }
  };

  const handleConfirmReset = async (e) => {
    e.preventDefault();
    console.log("Form submitted. Clearing previous errors.");

    // Clear previous errors and wait for half a second
    setError({});
    setTimeout(async () => {
      // Revalidate passwords after half a second
      console.log("Checking if passwords match...");
      if (newPassword !== confirmPassword) {
        console.log("Passwords do not match.");
        setError({ passwordMatch: "รหัสผ่านไม่ตรงกัน", newPassword: "error", confirmPassword: "error" });
        return;
      }

      console.log("Passwords match. Proceeding with password change request.");

      try {
        const response = await fetch(`${import.meta.env.VITE_API_URL}/change-password`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email, newPassword }),
        });

        if (response.ok) {
          navigate("/forgotpassword/success");
        } else {
          const data = await response.json();
          setError({ server: "Error: " + data.message, newPassword: "error", confirmPassword: "error" });
        }
      } catch (error) {
        setError({ httpRequest: "เกิดข้อผิดพลาดในการทำ HTTP request", newPassword: "error", confirmPassword: "error" });
      }
    }, 100); // 500 milliseconds = 0.5 second
  };

  const renderFloatLabelInput = (
    label,
    type,
    name,
    id,
    value,
    onChange,
    required = true,
    autoComplete = "off",
    hasError
  ) => (
    <div className={`float-label-wrapper ${hasError ? "error" : ""}`}>
      <input
        type={type}
        id={id}
        name={name}
        value={value || ""}
        onChange={onChange}
        className="float-input"
        required={required}
        placeholder=" "
        autoComplete={autoComplete}
      />
      <label htmlFor={id} className="float-label">
        {label} {required && <span className="required-star"> *</span>}
      </label>
    </div>
  );

  return (
    <div className="background-image">
      <div className="container">
        <form className="login-form" onSubmit={handleConfirmReset}>
          <div className="logo">
            <img src={logo} alt="Logo" style={{ marginRight: "8px" }} />
          </div>

          <div className="forgotPassword">
            <h2>ลืมรหัสผ่าน</h2>
            <p>ตั้งรหัสและยืนยันรหัสผ่านใหม่</p>

            <div className="forgotPasswordInput">
              <div style={{ position: "relative" }}>
                {renderFloatLabelInput(
                  "รหัสผ่านใหม่",
                  newPasswordType,
                  "newPassword",
                  "newPassword",
                  newPassword,
                  handleNewPasswordChange,
                  true,
                  "off",
                  error.newPassword === "error" || error.server === "error"
                )}
                <a
                  type="button"
                  className="toggle-password-button"
                  onMouseDown={handleMouseDownNewPassword}
                  onMouseUp={handleMouseUpNewPassword}
                >
                  <img
                    src={newPasswordType === "password" ? eyeOpen : eyeClose}
                    alt={newPasswordType === "password" ? "แสดงรหัสผ่าน" : "ซ่อนรหัสผ่าน"}
                  />
                </a>
              </div>
              <div style={{ position: "relative" }}>
                {renderFloatLabelInput(
                  "ยืนยันรหัสผ่านใหม่",
                  confirmPasswordType,
                  "confirmPassword",
                  "confirmPassword",
                  confirmPassword,
                  handleConfirmPasswordChange,
                  true,
                  "off",
                  error.confirmPassword === "error" || error.server === "error"
                )}
                <a
                  type="button"
                  className="toggle-password-button"
                  onMouseDown={handleMouseDownConfirmPassword}
                  onMouseUp={handleMouseUpConfirmPassword}
                >
                  <img
                    src={confirmPasswordType === "password" ? eyeOpen : eyeClose}
                    alt={confirmPasswordType === "password" ? "แสดงรหัสผ่าน" : "ซ่อนรหัสผ่าน"}
                  />
                </a>
              </div>
            </div>

            <div className="errorMessages">
              {error.passwordMatch && (
                <p className="error-message">{error.passwordMatch}</p>
              )}
              {error.server && <p className="error-message">{error.server}</p>}
              {error.httpRequest && (
                <p className="error-message">{error.httpRequest}</p>
              )}
            </div>

            <button type="submit" className="ok-branch">
              ยืนยัน
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPasswordSetNewPassword;
